let fiatDepositDetails = [
    {
        BankName: "XVC Tech Investment Company Limited",
        BankDetails: {
            "Account No": "0000335010000002",
            "IBAN": "AE760960000335010000002",
            "Currency": "USD"

        }
    }
]
const config = {
    API_BASE_URL: "https://betaapi.doru.co",
    Self_custodium_URL:"https://betaselfcustody.doru.co",
    Encryption_Key:"C@Ddoe^7@@8kkPRK"
};
export { fiatDepositDetails, config };